import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box, CircularProgress } from "@mui/material";
import buildQuery from "../../utils/query-builder";
import { shipmentService } from "../../utils/services/shipmentService";
import Shipments from "../../components/shipments";
import { useLocation } from "react-router-dom";
import { shipmentFilterInitialState } from "../../utils/filter-config";

function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state?.columns.map((x) =>
          x?.key === action?.payload?.key ? { ...x, ...action.payload } : x
        ),
      };
    case "SET_OPTIONS":
      return {
        ...state,
        columns: state.columns.map((col) =>
          col.key === action.payload.key
            ? { ...col, options: action.payload.options }
            : col
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };
    case "EXISTING_DATA":
      return {
        ...state,
        columns: state.columns.map((x) => ({
          ...x,
          filter:
            action.data.filters.find((y) => y.key === x.key)?.values ||
            x.filter,
        })),
        limit: action.data.limit || state.limit,
      };
    default:
      return state;
  }
}
const Shipment = () => {
  const [filterData, dispatch] = useReducer(
    filterReducer,
    shipmentFilterInitialState
  );
  const [shipmentList, setShipmentList] = useState([]);
  const [page, setPage] = React.useState(0);
  const [dataCount, setDataCount] = useState(15);
  const [loading, setLoading] = useState(false);
  const [clientFilter, setClientFilter] = useState(null);
  const location = useLocation();

  const fetchShipment = async (signal) => {
    setLoading(true);
    try {
      const response = await shipmentService.fetch(
        clientFilter?._id,
        buildQuery(filterData, page),
        { signal }
      );

      setShipmentList(response.data);
      setDataCount(response?.total || 0);
    } catch (error) {
      console.error("Fetch failed:", error);
      setShipmentList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    fetchShipment(signal);
    return () => {
      controller.abort();
    };
  }, [page, filterData, clientFilter]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  useEffect(() => {
    let data = localStorage.getItem("shipment-filter-data");
    if (location.search.includes("child") && data) {
      localStorage.removeItem("shipment-filter-data");
      dispatch({
        type: "EXISTING_DATA",
        data: JSON.parse(data),
      });
    }
  }, []);

  return (
    <>
      <DashboardContainer
        onChangeFilter={handleFilterChange}
        filterData={filterData}
        fields={filterData.columns}
        header={"Shipments"}
        hideUploadButton
        hideAddButton
        manifest
        onClickRefresh={() => fetchShipment()}
        onSelectClient={(e) => {
          setClientFilter(e);
        }}
        selectedClient={clientFilter?.name}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <Shipments
            dataCount={dataCount}
            page={page}
            rowsPerPage={filterData.limit}
            setRowsPerPage={(e) =>
              dispatch({
                type: "UPDATE_LIMIT",
                payload: e,
              })
            }
            setPage={setPage}
            data={shipmentList}
            onChangeFilter={handleFilterChange}
            filterData={filterData}
            onDeleteData={fetchShipment}
          />
        )}
      </DashboardContainer>
    </>
  );
};

export default Shipment;
